/**
 * Create Demand Jet nudge helpers.
 * The intake nudge should reappear each time the user lands on Create Demand,
 * but stay hidden for the rest of that visit after they open Jet.
 */

export function isCreateDemandPath(pathname) {
  return String(pathname || '').startsWith('/client/demands/new');
}

/**
 * @param {{
 *   pathname?: string,
 *   role?: string,
 *   visitNudgeActive?: boolean,
 *   panelOpen?: boolean,
 * }} opts
 */
export function shouldShowJetIntakeNudge({
  pathname = '',
  role = 'CLIENT',
  visitNudgeActive = false,
  panelOpen = false,
} = {}) {
  const onIntake =
    isCreateDemandPath(pathname) && String(role || 'CLIENT').toUpperCase() === 'CLIENT';
  return Boolean(onIntake && visitNudgeActive && !panelOpen);
}

/**
 * Decide whether a navigation should activate the intake nudge for this visit.
 * Leaving Create Demand clears it; arriving (or re-arriving) turns it back on.
 *
 * @param {{ wasOnIntake: boolean, nowOnIntake: boolean }} opts
 * @returns {'show' | 'hide' | 'keep'}
 */
export function intakeNudgeVisitTransition({ wasOnIntake, nowOnIntake }) {
  if (nowOnIntake && !wasOnIntake) return 'show';
  if (!nowOnIntake && wasOnIntake) return 'hide';
  if (nowOnIntake && wasOnIntake) return 'keep';
  return 'hide';
}
